
export default class ProductSpecs {

  constructor() {
    const specTable = $('#spec-table-content')

    const specTableWidth = $('#spec-table').outerWidth()
    const specTableContentWidth = specTable.outerWidth()

    this.determineScrollIndicatorDisplay(specTableWidth, specTableContentWidth)

    const maxScrollPosition = specTable[0].scrollWidth - specTableContentWidth
    this.attachScrollEvent(specTable, maxScrollPosition)
    this.attachClickEvent(specTable)

    // We're just going initialize this one as hidden since the page should load in scrolled
    // all the way to the left.
    $('.spec-scroll-indicator.left').fadeOut()
  }

  private determineScrollIndicatorDisplay(tableWidth: number, contentWidth: number) {
    if (tableWidth <= contentWidth) {
      $(".spec-scroll-indicator").addClass('hide')
    } else {
      // If we're going to display the scroll indicators we want to adjust the height
      // so that it does not overlap with the browser scrollbar which heights can vary
      // across browsers.
      const specTableVisibleHeight = $('#spec-table').innerHeight()
      $('.spec-scroll-indicator').height(specTableVisibleHeight)
    }
  }

  private attachClickEvent(specTable: JQuery) {
    $('.spec-scroll-indicator').on("mousedown", (e) => {
      let scrollPosition = specTable.scrollLeft()
      const scrollLeft = e.currentTarget.classList.contains('left')
      scrollPosition = scrollLeft ? scrollPosition-150 : scrollPosition+150
      specTable[0].scrollTo({left: scrollPosition, behavior: 'smooth'})
    })
  }

  private attachScrollEvent(specTable: JQuery, maxScrollPosition: number) {
    const rightScrollIndicator = $('.spec-scroll-indicator.right')
    const leftScrollIndicator = $('.spec-scroll-indicator.left')

    specTable.on('scroll', () => {
      let scrollPosition = specTable.scrollLeft()
      scrollPosition >= maxScrollPosition ? rightScrollIndicator.fadeOut() : rightScrollIndicator.fadeIn()
      scrollPosition <= 0 ? leftScrollIndicator.fadeOut() : leftScrollIndicator.fadeIn()
    })
  }
}